import React from 'react'
import { useField } from 'react-final-form'
import AsyncSelect from 'react-select/async'

import PropTypes from 'prop-types'

import Error from './Error'

const customStyles = {
  control: base => ({
    ...base,
    '&:hover': { borderColor: '#222222' },
    boxShadow: 'none',
    borderColor: '#222222',
    minHeight: '3rem',
    borderWidth: '2px',
    borderRadius: 0
  })
}

const MultipleSelectField = ({
  name,
  label,
  validate,
  placeholder = 'Selecciona una o más opción(es)',
  className,
  loadOptions,
  ...props
}) => {
  const { input } = useField(name, { validate, ...props })

  return (
    <>
      <label htmlFor={`${name}-input`} className="block font-bold mb-2 mt-4 min-w-25">
        {label}
      </label>
      <AsyncSelect
        name={name}
        loadOptions={loadOptions}
        isClearable
        isSearchable
        isMulti
        className={className}
        styles={customStyles}
        placeholder={placeholder}
        closeMenuOnSelect={false}
        cacheOptions
        defaultOptions
        {...input}
      />
      <Error name={name} />
    </>
  )
}

export default MultipleSelectField

MultipleSelectField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  validate: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  loadOptions: PropTypes.func
}
